

export default {
    components: {
    },
    props: {
        unit: {
            type: Object,
            required: true,
        }
    },
    created() {
        let t = this;

        if (t.unit.employees) {
            t.unit.employees.forEach(item => {
                if (item.grant) {
                    let g = item.grant;

                    for (let key in g) {
                        if (key != 'id' && (g[key] == 1 || g[key] == 0))
                            g[key] = g[key] == 1;
                    }


                    for (let key in g) {
                        if (!g[key])
                            t.all[key] = false;
                    }

                }
            });
        }
    },
    activated() {
        let t = this;
    },
    methods: {

        updateAll() {

            let t = this;

            let a = {
                leave_req: true,
                clock_in: true,
                att_schedule: true,

                daily_report: true,

                paid_leave: true,
                unpaid_leave: true,
                event_leave: true,

                field_work: true,
                work_online: true,

                att_shift: true,

                clean_mgr: true,
            };

            t.unit.employees.forEach(item => {
                if (item.grant) {
                    let g = item.grant;
                    for (let key in g) {
                        if (!g[key])
                            a[key] = false;
                    }
                }
            });

            mirror(a, t.all);

        },

        updateToggles(p) {

            let t = this;

            t.unit.employees.forEach(item => {
                if (item.grant) {
                    let g = item.grant;

                    if (p == 1) {
                        g.paid_leave = g.leave_req;
                        g.unpaid_leave = g.leave_req;
                        g.event_leave = g.leave_req;
                    }

                    else if (p == 2) {
                        g.field_work = g.clock_in;
                        g.work_online = g.clock_in;
                    }

                    else if (p == 3) {
                        g.att_shift = g.att_schedule;
                    }
                }
            });

            t.updateAll();
        },

        updateToggles2() {

            let t = this;

            t.unit.employees.forEach(item => {
                if (item.grant) {
                    let g = item.grant;
                    g.daily_report = t.all.daily_report;
                    g.clean_mgr = t.all.clean_mgr;
                }
            });
        },

        updateAllToggles(type, field) {

            let t = this;

            if (type == 1) {
                t.all.paid_leave = t.all.leave_req;
                t.all.unpaid_leave = t.all.leave_req;
                t.all.event_leave = t.all.leave_req;

                t.unit.employees.forEach(item => {
                    if (item.grant) {
                        let g = item.grant;
                        g.leave_req = t.all.leave_req;
                        g.paid_leave = t.all.paid_leave;
                        g.unpaid_leave = t.all.unpaid_leave;
                        g.event_leave = t.all.event_leave;
                    }
                });
            }
            else {
                t.unit.employees.forEach(item => {
                    if (item.grant) {
                        let g = item.grant;
                        g[field] = t.all[field];
                    }
                });
            }


        },

        updateAllToggles2(type, field) {

            let t = this;

            if (type == 1) {

                t.all.field_work = t.all.clock_in;
                t.all.work_online = t.all.clock_in;

                t.unit.employees.forEach(item => {
                    if (item.grant) {
                        let g = item.grant;

                        g.clock_in = t.all.clock_in;
                        g.field_work = t.all.field_work;
                        g.work_online = t.all.work_online;
                    }
                });
            }
            else {
                t.unit.employees.forEach(item => {
                    if (item.grant) {
                        let g = item.grant;
                        g[field] = t.all[field];
                    }
                });
            }



        },

        updateAllToggles3(type, field) {

            let t = this;

            if (type == 1) {
                t.all.att_shift = t.all.att_schedule;
                t.unit.employees.forEach(item => {
                    if (item.grant) {
                        let g = item.grant;
                        g.att_schedule = t.all.att_schedule;
                        g.att_shift = t.all.att_shift;
                    }
                });
            }
            else {
                t.unit.employees.forEach(item => {
                    if (item.grant) {
                        let g = item.grant;
                        g[field] = t.all[field];
                    }
                });
            }



        },

        saveAccessGrant() {
            let t = this;

            let data = [];

            if (t.busying)
                return;

            t.busying = true;

            t.unit.employees.forEach(item => {
                if (item.grant) {
                    let g = item.grant;
                    data.push(g);
                }
            });

            axios.post('grant/batchSave', { items: data }).then(res => {
                t.busying = false;

                if (res.data.status == 1) {
                    A.toast('Saved.');
                    t.$emit('close');
                }
            });

        }
    },
    data() {
        return {
            more: {
                leave_req: true,
                clock_in: true,
                att_schedule: true,
            },
            all: {
                leave_req: true,
                clock_in: true,
                att_schedule: true,

                daily_report: true,

                paid_leave: true,
                unpaid_leave: true,
                event_leave: true,

                field_work: true,
                work_online: true,

                att_shift: true,

                clean_mgr: true,
            }
        };
    },
    computed: {
    }
};
